import pluralize from "pluralize"
import PropTypes from "prop-types"
import React from "react"
import { QueryClient, useMutation } from "react-query"
import { useMarina } from "src/contexts/MarinaContext"

import AlertBanner from "src/components/AlertBanner"
import Button from "src/components/Button"

import { markFuelPricesUpToDate } from "src/api/Dashboard"

import { useToast } from "src/hooks/use_toast"
import { useTracker } from "src/hooks/use_tracker"

const FuelPriceAlertBanner = ({
  fuelPricesStale,
  currentFuelPriceRequestCount,
  showAlertBanner,
  setShowAlertBanner,
  location,
}) => {
  const queryClient = new QueryClient()
  const showToast = useToast()
  const { marinaSlug } = useMarina()
  const tracker = useTracker()

  const handleMarkAsUpToDate = () => {
    tracker.trackEvent("fuel_prices:mark_as_up_to_date_clicked", {
      mcomId: marinaSlug,
      location,
    })
    markAsUpToDate()
  }

  const { mutate: markAsUpToDate } = useMutation(
    () => markFuelPricesUpToDate(marinaSlug),
    {
      onSuccess: (data) => {
        showToast(data.message, { type: "success" })
        queryClient.invalidateQueries(["listedPumpPricesForm", marinaSlug])
        setShowAlertBanner(false)
      },
      onError: (error) => {
        showToast(error.message, { type: "error" })
      },
    }
  )
  if (
    (fuelPricesStale || currentFuelPriceRequestCount > 0) &&
    showAlertBanner
  ) {
    return (
      <div className="mt-4">
        <AlertBanner type="info">
          <div className="flex items-center space-x-2">
            <i className="fa-kit fa-fuel text-xl" />
            <span>
              {fuelPricesStale &&
                "Your fuel prices have not been updated in at least 30 days. "}
              {currentFuelPriceRequestCount > 0 &&
                `There has been ${currentFuelPriceRequestCount} 
                      boater 
                      ${pluralize(
                        "request",
                        currentFuelPriceRequestCount
                      )} for updated pump prices. `}
              Update your prices or{" "}
              <Button onClick={handleMarkAsUpToDate} variant="link">
                mark as up-to-date.
              </Button>
            </span>
          </div>
        </AlertBanner>
      </div>
    )
  }
}

FuelPriceAlertBanner.propTypes = {
  fuelPricesStale: PropTypes.bool,
  currentFuelPriceRequestCount: PropTypes.number,
  showAlertBanner: PropTypes.bool.isRequired,
  setShowAlertBanner: PropTypes.func.isRequired,
  location: PropTypes.oneOf(["dashboard", "settings-public-profile"]),
}

export default FuelPriceAlertBanner
